import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Anchor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ROUTE_PATHS } from '@/lib/index';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('ave_admin_auth') === 'true') {
      navigate(ROUTE_PATHS.ADMIN_DASHBOARD);
    }
  }, [navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    setTimeout(() => {
      if (pin === 'AVE2026!') {
        sessionStorage.setItem('ave_admin_auth', 'true');
        navigate(ROUTE_PATHS.ADMIN_DASHBOARD);
      } else {
        setError('Incorrect PIN. Please try again.');
        setIsSubmitting(false);
      }
    }, 300);
  };

  return (
    <div className="min-h-screen bg-primary flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/10 mb-6">
            <Anchor className="w-8 h-8 text-accent" />
          </div>
          <h1 className="text-4xl font-serif font-bold text-accent mb-2">
            ANCHOR VAULT ESTATE
          </h1>
          <p className="text-lg text-muted-foreground">Admin Access</p>
        </div>

        <div className="bg-card rounded-xl p-8 shadow-lg border border-border">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="pin" className="text-foreground">
                Admin PIN
              </Label>
              <Input
                id="pin"
                type="password"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                placeholder="Enter admin PIN"
                className="bg-background border-border"
                disabled={isSubmitting}
                autoFocus
              />
              {error && (
                <p className="text-sm text-destructive mt-2">{error}</p>
              )}
            </div>

            <Button
              type="submit"
              className="w-full bg-accent hover:bg-accent/90 text-accent-foreground"
              disabled={isSubmitting || !pin}
            >
              {isSubmitting ? 'Verifying...' : 'Access Admin Panel'}
            </Button>
          </form>
        </div>

        <p className="text-center text-sm text-muted-foreground mt-6">
          © 2026 Anchor Vault Estate. All rights reserved.
        </p>
      </div>
    </div>
  );
}
